import React, { useCallback } from 'react'

import { Button } from 'src/govwell-ui'

import { useStaffAIAssistant } from './StaffAIAssistantContext'

/**
 * A pill-shaped button that opens the Staff AI Assistant in side view mode.
 * Positioned in the upper right corner of the content area.
 * Visibility is controlled by the parent (SidebarLayout).
 */
const StaffAIAssistantPill = () => {
  const context = useStaffAIAssistant()

  const handleClick = useCallback(() => {
    context?.openSideView()
  }, [context])

  return (
    <Button
      variant="default"
      size="sm"
      icon="FaSparkles"
      onClick={handleClick}
      ariaLabel="Open AI Assistant"
      className="!fixed !top-[6px] !right-[14px] !z-[100] !h-auto !rounded-full !px-3 !py-1 !shadow-sm !transition-all !duration-200 after:!rounded-full after:!inset-shadow-none hover:!border-orange-500 hover:!bg-orange-500 hover:!text-white [&_span]:!text-[11px] [&_span]:!font-medium"
    >
      AI Assistant
    </Button>
  )
}

export default React.memo(StaffAIAssistantPill)
